// extracted by mini-css-extract-plugin
export default {"modal":"customModal_modal__CGqqm","close-button":"customModal_close-button__aYDcR"};